import { render, staticRenderFns } from "./ResendAccessCode.vue?vue&type=template&id=5fe7d9d6"
import script from "./ResendAccessCode.vue?vue&type=script&lang=js"
export * from "./ResendAccessCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports